<template>
    <div class="info_intro">
        <i-row>
            <i-col span="20" offset="2">
                <i-carousel autoplay loop>
                    <i-carouselItem v-for="item in slideDate">
                        <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                    </i-carouselItem>
                </i-carousel>
            </i-col>
        </i-row>
        <i-row class="margintop">
            <i-col span="8" offset="2">
                <div>
                    <em class="line-r" style="width: 100%;"></em><br>
                </div>
            </i-col>
            <i-col span="4" style="text-align: center">
                <span class="title_head">组织机构</span>
                <br/>
                <span class="lang_eng">TEAM SHOWCASE</span>
            </i-col>
            <i-col span="8">
                <div>
                    <em class="line-l" style="width: 100%;"></em><br>
                </div>
            </i-col>
        </i-row>
        <i-row class="margintop" style="margin-bottom: 30px;">
            <i-col span="3" offset="3" class="verticalMenu">
                <i-menu active-name="org" style="text-align: center;width: 100%;" @on-select="routeTo">
                    <i-menuItem name="intro">
                        <i-icon type="md-document" />
                        大赛简介<br>
                        INTRODUCTION
                    </i-menuItem>
                    <i-menuItem name="notice">
                        <i-icon type="md-chatbubbles" />
                        参赛须知<br>
                        NOTES
                    </i-menuItem>
                    <i-menuItem name="arrange">
                        <i-icon type="ios-ribbon" />
                        赛事安排<br>
                        TRAVEL
                    </i-menuItem>
                    <i-menuItem name="news">
                        <i-icon type="md-document" />
                        大赛新闻<br>
                        NEWS
                    </i-menuItem>
                    <i-menuItem name="team_show">
                        <i-icon type="ios-people" />
                        团队展示<br>
                        TEAM SHOWCASE
                    </i-menuItem>
                    <i-menuItem name="org">
                        <i-icon type="ios-contacts" />
                        组织机构<br>
                        TEAM SHOWCASE
                    </i-menuItem>
                    <i-menuItem name="contact">
                        <i-icon type="ios-chatboxes" />
                        联系我们<br>
                        CONTACT US
                    </i-menuItem>
                </i-menu>
            </i-col>
            <i-col span="13" offset="1">
                <div v-html="details"></div>
            </i-col>
        </i-row>
    </div>
</template>

<script>
  import { Icon, Col, Row, Carousel, CarouselItem ,Breadcrumb ,BreadcrumbItem,Menu,MenuGroup,MenuItem  } from 'iview';
  import {api_getData} from '../../api/carousel';
  import {api_getOthers} from '../../api/info';
  import {url} from '../../config';

  export default {
    name: '',
    components: {
      'i-col': Col,
      'i-row': Row,
      'i-icon': Icon,
      'i-carousel' : Carousel,
      'i-carouselItem' : CarouselItem,
      'i-breadcrumb' : Breadcrumb,
      'i-breadcrumbItem' : BreadcrumbItem,
      'i-menu' : Menu,
      'i-menuGroup' : MenuGroup,
      'i-menuItem' : MenuItem,
    },
    data() {
      return {
        slideDate : [],
        url : url,
        details : '',
      }
    },
    async created() {
      let _data = await api_getData('org');
      let res = _data.body;
      if (res.code === 0) {
        this.slideDate = res.data;
      }

      let _data2 = await api_getOthers('org');
      let res2 = _data2.body;
      if (res2.code === 0) {
        this.details = res2.details;
      }
    },
    methods: {
      routeTo(name){
        this.$router.push({name : 'info_' + name , params: {ver_name : name}});
      }
    }
  }
</script>

<style lang="scss">
.info_intro{
    text-align: left;
    /*轮播图设置*/
    .carousel{
        .carousel_img{
            width: 100%;
            height: 100%;
        }
    }

    /*row间距设置*/
    .margintop{
        margin-top: 20px;
    }

    /*菜单栏start*/
    .verticalMenu {
        .ivu-menu-light {
            background: #d9b2ff;
        }
        .ivu-menu {
            display: block;
            border-radius: 40px;
            overflow: hidden;
            color: #ffffff;
            font-size: 14px;
            position: relative;
        }
        .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
            color: #ffffff;
            font-weight: 600;
            background: rgb(153, 51, 255);
            z-index: 2;
        }
        .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
            color: #3d2404;
        }
        .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
            content: '';
            display: block;
            width: 2px;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            background: #e5ea20;
        }
    }
    /*菜单栏end*/

    /*小标题start*/
    .title_head{
        color: #9933CC;
        font-weight: 600;
        font-size: 18px;
    }
    .lang_eng{
        /*color: rgb(255,165,51);*/
        font-size: 16px;
    }
    /*小标题end*/

    /*长线*/
    .line-l::after, .line-r::after {
                content: '';
                position: absolute;
                right: -4px;
                top: -7px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                border: 1px solid #8d40ef;
            }

            .line-l, .line-r {
                position: absolute;
                /*left: 0;*/
                top: 28px;
                width: 100px;
                height: 1px;
                background: #8d40ef;
            }

            em {
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-family: 微软雅黑, "Microsoft YaHei";
                margin: 0px;
                padding: 0px;
                list-style: none;
            }

            .line-r {
                right: 0;
                left: initial;
            }

            .line-r::after {
                left: -5px;
                right: initial;
            }
}
</style>
